import {NavigationItem} from "../../../models/NavigationItem";
import Menu from "./menu/menu";
import MenuDropdown from "./MenuDropdown";
import './Navigation.scss';

import { Link } from "react-router-dom";
import Sidedrawer from "../../pages/sidedrawer/Sidedrawer";
import {Button, Tabs, Toolbar, useMediaQuery, useTheme} from "@mui/material";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {inspect} from "util";
import React, { useEffect } from "react";
import {faChevronDown} from '@fortawesome/free-solid-svg-icons'
import axios from "axios";
import { CacheService } from "../../../common/services/cache.service";
import environment from "../../../environment/environment";
import APIService from "../../../services/api.service";
import { useRecoilState, useRecoilValue } from "recoil";
import { userState } from "../../../atoms/user";
import { adminState } from "../../../atoms/isAdmin";
import { useAuth } from "../../../hooks/useAuth";


const Navigation = () => {
  const [isAdmin, setIsAdmin] = useRecoilState(adminState);
  const [userInfo, setuserInfo] = useRecoilState(userState);
  const { isAuthenticated, user, isLoading } = useAuth();
  console.log('Nav auth state:', { isAuthenticated, isLoading, hasUser: !!user, hasToken: !!user?.access_token });
  console.log('isAdmin', isAdmin);

  useEffect(() => {
    // Skip if in public mode or not authenticated yet
    if (environment.publicMode || !isAuthenticated || !user?.access_token) {
      return;
    }

    const url = `${environment.npgApiUrl}user/current`;
    axios.get(url, { 
      headers: {
        'Authorization': 'Bearer ' + user.access_token
      }, 
      withCredentials: true
    }).then(res => {
      console.log('nav axiosget', res);
      let roles: string[] = res.data.roles;
      setIsAdmin(roles.includes('etic_admin'));

      setuserInfo(res.data);
    }).catch(err => {
      console.error('Failed to fetch user data:', err);
    });   
  }, [isAuthenticated, user?.access_token, setIsAdmin, setuserInfo]);

    const menuItemClassName = ({ hover }) =>
      hover ? 'my-menuitem-hover' : 'my-menuitem';

    const generalInfoItems: NavigationItem[] = [
      {title: 'Overview', url: './overview'},
      {title: 'Security Guidelines', url: './securityguidelines'},
      {title: 'Working with TIC', url: './workingwithtic'}];

    const resourceItems: NavigationItem[] = environment.publicMode 
      ? [{title: 'Park Index', url: './parkindex'}]
      : [
          {title: 'Park Index', url: './parkindex'},
          {title: 'Request A Tic Number', url: './requestTicNum'}
        ];

    const helpItems: NavigationItem[] = [
      {title: 'Help Page', url: './HelpPage'},
      {title: 'FAQs', url: './Faqs'},
      {title: 'Accessibility', url: './Accessibility'},
      {title: 'Security Guidelines', url: './SecurityGuidelines'},
    ];

    const aboutItems: NavigationItem[] = [
      {title: 'Archiving With TIC', url: './archiving'},
      {title: 'Mission Statement', url: './missionstatement'}];

    const fileUpload: NavigationItem[] = [
      {title: 'File Upload', url: './upload'}];

    const contactItems: NavigationItem[] = [
      {title: 'Contact Us', url: './teams'},
      {title: 'Microsoft Teams', url: './chat'}];

    const accountItems: NavigationItem[] = [
      {title: 'Order History', url: './orderHistory'},
      {title: 'My Requested TIC Numbers', url: './ticNumbers'},
      {title: 'My Uploads', url: './myUploads'}];
  
    const adminItems: NavigationItem[] = [
      {title: 'Admin', url: './admin'},
      //{title: 'New Users', url: './newUsers'},
      {title: 'Statistics', url: './statistics'},
      {title: 'Announcements', url: './announcements'},
      {title: 'Orders', url: './orders'},
      {title: 'Pending TIC Numbers', url: './pendingTic'},
      {title: 'Assigned TIC Numbers', url: './assignedTic'},
      //{title: 'Record Entry', url: './recordEntry'},
      {title: 'Record Entry', url: './record'},
      {title: 'User Uploads', url: './userUploads'}];    

    const theme = useTheme()
    const isMatch = useMediaQuery(theme.breakpoints.down('md'))

    return (
        <>
          { (isAuthenticated || environment.publicMode) && <> 
            {isMatch ? (
                <div className="sidedrawer">
                    <Sidedrawer>
                    </Sidedrawer>
                </div>
            ) : (

                <div className="container">
                    <Link to={"/"} aria-label="Home">
                        <button>
                            <span className="search">Home</span>
                        </button>
                    </Link>

                    <Menu title={"Resources"} menuItems={resourceItems} ></Menu>
                    <FontAwesomeIcon icon={faChevronDown} size={'xs'} color={'white'} /> &nbsp; &nbsp;

                    {!environment.publicMode && (
                      <>
                        <Menu title={"File Upload"} menuItems={fileUpload}></Menu> &nbsp; &nbsp;
                      </>
                    )}

                    <Menu title={"Help | FAQ"} menuItems={helpItems}></Menu>
                    <FontAwesomeIcon icon={faChevronDown} size={'xs'} color={'white'} /> &nbsp; &nbsp;

                    <Menu title={"About"} menuItems={aboutItems}></Menu>
                    <FontAwesomeIcon icon={faChevronDown} size={'xs'} color={'white'} /> &nbsp; &nbsp;

                    {!environment.publicMode && (
                      <>
                        <Menu title={"Contact"} menuItems={contactItems}></Menu>
                        <FontAwesomeIcon icon={faChevronDown} size={'xs'} color={'white'}  /> &nbsp; &nbsp;
                      </>
                    )}

                    {!environment.publicMode && (
                      <>
                        <Menu title={"Account"} menuItems={accountItems}></Menu>
                        <FontAwesomeIcon icon={faChevronDown} size={'xs'} color={'white'}  /> &nbsp; &nbsp;
                      </>
                    )}

                    {
                      !environment.publicMode && (isAdmin || userInfo?.roles?.includes('etic_admin')) &&
                      <>
                        <Menu title={"TIC Admin"} menuItems={adminItems}></Menu>
                        <FontAwesomeIcon icon={faChevronDown} size={'xs'} color={'white'}  /> &nbsp; &nbsp;
                      </>
                    }
                    
                </div>

            )}
            </>
          }
        </>
    );
}

export default Navigation;
